import { Component, Input, Output } from 'angular-ts-decorators';
import { CustomizerFilter, FilterOption } from '../../models';
import { IHeroCustomizerV2FilterComponent } from '../models/hero-customizer-v2.filter.component';

import template from './hero-customizer-v2.filter-checkbox.component.html';

@Component({
  selector: 'heroCustomizerV2FilterCheckbox',
  template,
})
export class HeroCustomizerV2FilterCheckboxComponent implements IHeroCustomizerV2FilterComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public filter?: CustomizerFilter;

  @Output() public onFilterChange?: ({ filter: CustomizerFilter }) => void;

  public onOptionClicked(option: FilterOption) {
    option.checked = !option.checked;
    if (this.onFilterChange) {
      this.onFilterChange({ filter: this.filter });
    }
  }
}
